import React from 'react';

import { Box, ButtonBase, Typography } from '@mui/material';

import { AttentionRow, rowPill, stepLabel } from './AttentionList';
import { UI, cardSx, value } from './operationalUi';

export default function EmptyCampaign({
  rows,
  onCampaign,
}: {
  rows: AttentionRow[];
  onCampaign: (id: string) => void;
}) {
  return (
    <Box sx={{ height: '100%', minHeight: 0, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ ...cardSx, textAlign: 'center', py: 3 }}>
        <Box aria-hidden="true" sx={{ width: 190, mx: 'auto', mb: 2 }}>
          {[100, 75, 50, 30].map((w) => (
            <Box
              key={w}
              sx={{ width: w + '%', height: 18, mb: 0.5, mx: 'auto', bgcolor: UI.line, borderRadius: 0.5 }}
            />
          ))}
        </Box>
        <Typography sx={{ fontSize: 20, fontWeight: 600, color: UI.teal }}>Choose a campaign</Typography>
        <Typography sx={{ fontSize: 14, color: UI.muted, mt: 0.5 }}>
          Pick a campaign to see how it is tracking against its peers.
        </Typography>
      </Box>
      <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Start with a campaign below peers</Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4,minmax(0,1fr))',
          gap: 1.5,
          '@container (max-width: 1000px)': { gridTemplateColumns: 'repeat(2,minmax(0,1fr))' },
          '@container (max-width:600px)': { gridTemplateColumns: 'minmax(0,1fr)' },
        }}
      >
        {rows.slice(0, 8).map((row) => (
          <ButtonBase
            key={row.id}
            data-lens-pdf-keep=""
            onClick={() => onCampaign(row.id)}
            sx={{ ...cardSx, display: 'block', textAlign: 'left', p: 2, minHeight: 150 }}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 600, mb: 0.75 }}>{row.name}</Typography>
            {rowPill(row)}
            <Typography sx={{ fontSize: 12, color: UI.muted, mt: 1 }}>{stepLabel(row.weakestStep)}</Typography>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: row.positions.margin_per_day === 'below' && !row.tooEarly ? UI.below.color : UI.teal,
                mt: 0.5,
              }}
            >
              {value(row.gap, 'currency')}
            </Typography>
          </ButtonBase>
        ))}
      </Box>
      {!rows.length && (
        <Typography sx={{ fontSize: 14, color: UI.muted }}>
          No mature campaigns are below peers in this scope. Use the campaign picker to inspect another campaign.
        </Typography>
      )}
    </Box>
  );
}
